const isNull = data => {
  let value = data.value
  value = value.trim()
  return value === '' || value === null ? '' : true
}

export default isNull
